module.exports = __webpack_public_path__ + "static/img/kbz-805-365-85bb.40beeaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/kbz-805-365-85bb.jpg
// module id = p8DW
// module chunks = 0